// extracted by mini-css-extract-plugin
export default {"counter_status":"CounterStatus_counter_status__XmU3E","main_value":"CounterStatus_main_value__v+Fl+","main_label":"CounterStatus_main_label__v5qSt"};